import { ProductionPriceCondition } from './state-models/production-price-condition';
import { ProductionPriceList, ProductionPriceListForm } from './state-models/production-price-list';
import { Paging } from "src/state/common/state-models/paging";

export interface ProductionPriceListState {
    productionPriceList: ProductionPriceCondition[];
    formProductionPriceList: ProductionPriceList[];
    productionPriceListSortExpression: string;
    productionPriceListFilterExpression: string;
    productionPriceListTotalCount: number;
    productionPriceListPaging: Paging;
    showOnlyValidConditions:boolean;
}
